import type { FC } from "react";

import styled, { css } from "styled-components";

import { mixins, colorsPalettes, rgba } from "@similarweb/styles";

interface ILegend {
    color: string;
    name: string;
    isMain?: boolean;
    size?: "s" | "m";
}

interface ILegendStyled {
    isMain: boolean;
    size: any;
}

const LegendStyled = styled.div<ILegendStyled>`
    display: flex;
    align-items: center;
    ${({ isMain, size }) =>
        !isMain &&
        css`
            ${mixins.setFont({
                $color: rgba(colorsPalettes.carbon[500], 0.8),
                $weight: 400,
                $size: size === "m" ? "14px" : "12px",
            })}
        `};
    ${({ isMain, size }) =>
        isMain &&
        css`
            ${mixins.setFont({
                $color: rgba(colorsPalettes.carbon[500], 0.8),
                $weight: 600,
                $size: size === "m" ? "14px" : "12px",
            })}
        `};
    margin-right: 8px;
`;

export const Marker = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ color }) => color};
    margin-right: 8px;
`;

const LegendText = styled.span``;

export const Legend: FC<ILegend> = ({ color, name, isMain = false, size = "m" }) => {
    return (
        <LegendStyled
            isMain={isMain}
            size={size}
        >
            <Marker color={color} />
            <LegendText>{name}</LegendText>
        </LegendStyled>
    );
};
